import * as React from 'react'

import { LucideIcon } from 'lucide-react'
import { Input } from '@bpinternal/ui-kit-next'
import { cn } from '~/utils'

const IconInput = React.forwardRef<
  HTMLInputElement,
  React.ComponentProps<'input'> & { startIcon?: LucideIcon; endIcon?: LucideIcon }
>(({ className, type, startIcon, endIcon, ...props }, ref) => {
  const StartIcon = startIcon
  const EndIcon = endIcon

  return (
    <div className="relative w-full">
      {StartIcon && (
        <div className="absolute left-1.5 top-1/2 -translate-y-1/2 transform">
          <StartIcon size={16} className="text-muted-foreground" />
        </div>
      )}
      <Input type={type} className={cn({ 'pl-6': startIcon }, { 'pr-6': endIcon }, className)} ref={ref} {...props} />
      {EndIcon && (
        <div className="absolute right-1.5 top-1/2 -translate-y-1/2 transform">
          <EndIcon className="text-muted-foreground" size={16} />
        </div>
      )}
    </div>
  )
})
IconInput.displayName = 'IconInput'

export { IconInput }
